// Nom de fichier des photos téléchargées depuis le dashboard : date d'envoi
// et id en base dedans, pour qu'une photo archivée puis supprimée reste
// rattachable à sa fiche (cf. export scripts/exportPhotoArchive.mjs).
// Ex. : rudyrigoudy-ar-2026-09-14-id57.jpg, photo-carte-2026-09-14-id12.jpg,
// sillages-camille+yohan_rdy-2026-10-22-id3.png (photo de la page
// Sillages, toujours en PNG)
export function photoDownloadName({ type, id, pseudo, createdAt, s3Key }) {
  if (type === 'sphere') {
    const caption = sphereCaptionSlug(pseudo);
    return `sillages-${caption ? `${caption}-` : ''}${new Date(createdAt).toISOString().slice(0, 10)}-id${id}.png`;
  }
  const slug = (pseudo || '').replace(/^@/, '').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 40);
  const day  = new Date(createdAt).toISOString().slice(0, 10);
  const kind = type === 'ar' ? 'ar' : (slug ? 'map' : 'carte');
  const base = slug ? `${slug}-${kind}` : `photo-${kind}`;
  const ext  = /\.png$/i.test(s3Key || '') ? 'png' : 'jpg';
  return `${base}-${day}-id${id}.${ext}`;
}

// Légende d'une photo de la page Sillages ("@camille, @yohan_rdy", "Tous les
// punchliners"...) réduite pour un nom de fichier : "camille+yohan_rdy",
// "tous-les-punchliners" (minuscules : les pseudos Instagram ne tiennent
// pas compte de la casse). Au-delà de SPHERE_SLUG_MAX caractères, les
// pseudos restants sont résumés ("+12-autres") -- les premiers gardés sont
// les plus anciens contributeurs (ordre de la légende, cf. sillageMain.js).
const SPHERE_SLUG_MAX = 100;

export function sphereCaptionSlug(caption) {
  const clean = (text) => text.trim().toLowerCase().replace(/^@/, '').replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/^-+|-+$/g, '');
  const parts = (caption || '').split(',').map(clean).filter(Boolean);
  if (parts.length <= 1) return (parts[0] || '').slice(0, SPHERE_SLUG_MAX);
  let slug = '';
  for (let i = 0; i < parts.length; i++) {
    const next = slug ? `${slug}+${parts[i]}` : parts[i];
    if (next.length > SPHERE_SLUG_MAX && slug) return `${slug}+${parts.length - i}-autres`;
    slug = next;
  }
  return slug;
}
